export default class FabricAddText{
    constructor(text,fill, textAlign){
        this.fill = fill
        this.width = 400
        this.cursorColor = "blue"
        this.top = 10
        this.left = 10
        this.textAlign = textAlign
        this.text = text
        this.lineHeight = 0.8
        this.fontFamily = 'Lato'
        this.align = 'mid'
        this.originX = 'center'
        this.originY = 'center'
    }
}